/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Workshopfilter1Inputs */

const de__field_workshopfilter1 = /** @type {(inputs: _Field_Workshopfilter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungstitel`)
};

/**

* @param {_Field_Workshopfilter1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_workshopfilter1 = /** @type {((inputs?: _Field_Workshopfilter1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Workshopfilter1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_workshopfilter1(inputs)
});
export { _field_workshopfilter1 as "_field_workshopFilter" }